export const imports = {
  form: {
    clickOrDrag: 'Click or drag file to this area to upload',
  },
  pageHeader: {
    title: 'CSV Import',
    download: 'Download CSV Example',
    importOverWrite: 'Import CSV ( Over Write )',
    importInsert: 'Import CSV ( Insert )',
  },
}
